type FieldColumn = { id: string; name: string };

export const selectOnChangeScriptsForField = <TScript extends object>(
    scripts: TScript[],
    columns: FieldColumn[],
    fieldName: string
): TScript[] => scripts.filter((script) => {
    const targetField = (script as { field_name?: string | null }).field_name;
    const targetColumn = columns.find((column) => column.id === targetField || column.name === targetField);
    return !targetField || targetField === fieldName || targetColumn?.name === fieldName;
});

export const isSameValueDispatchNeeded = (
    snapshot: Record<string, unknown> | null,
    currentValue: unknown,
    fieldName: string
): boolean => snapshot !== null &&
    JSON.stringify(snapshot[fieldName]) === JSON.stringify(currentValue);
